import React from "react";
import curve from "../../assets/icons/curvyline.svg";

const ServiceBanner = () => {
	return (
		<section className='bg-[#45E99E] bg-fixed overflow-hidden'>
			<div
				id='hero'
				className='max-w-[1440px] mx-auto w-[90%] text-center lg:pt-40 pt-24 pb-16 bg-cover bg-no-repeat relative '>
				<div className=' z-10 text-center'>
					<img
						src={curve}
						alt='Curve Decoration'
						className='absolute lg:top-[50%] top-[40%] xl:left-[-10%] lg:left-[-17%] sm:left-[-25%] left-[-50%]'
					/>

					<h1 className='lg:text-[72px]/[79px] text-[40px]/[49px] lg:tracking-[-2px] tracking-[-1.72px] font-medium text-[11112d] mb-4'>
						How We Serve You
					</h1>

					<p className='max-w-[1150px] w-full mx-auto  md:text-xl/[30px] text-xs/[21px] text-[11112d]'>
						At SynergyCare Foundation, we provide holistic support to
						under-served populations by addressing both healthcare requirements
						and the broader social factors that impact well-being. Our
						comprehensive programs ensure that every individual receives the
						necessary care and resources to lead a healthier life while
						fostering community resilience.
					</p>
					<img
						src={curve}
						alt='Curve Decoration'
						className='absolute lg:top-[50%] top-[40%] xl:right-[-10%] lg:right-[-17%] sm:right-[-25%] right-[-50%]'
					/>
				</div>
			</div>
		</section>
	);
};

export default ServiceBanner;
